/**
 * Adds a specified number of days to a given date and returns the resulting date.
 *
 * @param date - The date to which days are added, provided as a Date object or a date string.
 * @param days - The number of days to add to the date.
 * @returns The resulting date after adding the specified number of days.
 */
export function addDays(date: string | Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);

  return result;
}
